import { Component, OnInit, Inject } from '@angular/core';
import { BackOfficeService } from 'src/app/services/back-office.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Login } from 'src/app/models/login.model';
import { CommonService } from 'src/app/services/common.service';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { ModalLikeSweetComponent } from '../modal-like-sweet/modal-like-sweet.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  productId: number;
  personGroup: FormGroup;
  businessGroup: FormGroup;
  mode: string = 'persona';

  constructor(private backOfficeService: BackOfficeService,
              private formBuilder: FormBuilder,
              private commonService: CommonService,
              private matDialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) private input: any,
              private environmentService: EnvironmentService) { }

  ngOnInit() {
    this.productId = this.input.productId;
    this.createForm();
  }
  createForm() {
    this.personGroup = this.formBuilder.group({
      username: [, [Validators.required, Validators.email]],
      password: [, [Validators.required]]
    });
    this.businessGroup = this.formBuilder.group({
      username: [, [Validators.required, Validators.pattern('^([0-9]){11,11}$')]],
      password: [, [Validators.required]]
    });
  }
  switchLoginMode(mode: string) {
    this.mode = mode;
  }
  async login() {
    let formGroup: FormGroup;
    switch (this.mode) {
      case 'persona':
        formGroup = this.personGroup;
        break;
      case 'empresa':
        formGroup = this.businessGroup;
        break;
      default:
        break;
    }
    if (formGroup.valid) {
      let data = new Login();
      data.username = formGroup.get('username').value;
      data.password = formGroup.get('password').value;
      data.platform = '2';

      this.backOfficeService.getTemporaryAccess(data).subscribe(response => {
        if (response.valid) {
          window.top.location.href = this.environmentService.virtualOfficeFront + 'ofivirtual/vrfccn?ftrlgn=tienda%2Fcarrito%3Fprdct%3D' + this.productId + '&&crdntls=' + response.data;
        } else {
          this.showLikeSweet([response.message], true, false);
        }
      });
    } else {
      this.getErrors(formGroup);
    }

  }
  getErrors(formGroup: FormGroup) {
    let errors = [];
    if (formGroup.get('username').hasError('required')) {
      switch (this.mode) {
        case 'persona':
          errors.push('Debe ingresar su correo.');
          break;
        case 'empresa':
          errors.push('Debe ingresar su ruc.');
          break;
        default:
          break;
      }
    } else if (formGroup.get('username').hasError('email')) { errors.push('Debe ingresar un correo válido.'); }
    else if (formGroup.get('username').hasError('pattern')) { errors.push('Debe ingresar un ruc válido de 11 dígitos.'); }

    if (formGroup.get('password').hasError('required')) { errors.push('Debe ingresar su contraseña.'); }

    this.showLikeSweet(errors, false, true);
  }

  showLikeSweet(errors: any, showInfo: boolean, showRequired: boolean){
    this.matDialog.open(ModalLikeSweetComponent, {
      data: {
        message: this.commonService.getErrorHtmlListForLogin(errors),
        showInfo,
        showRequired
      },
      position: {
        top: (this.input.clientY - 180)+'px'
      },
      width: '512px',
      panelClass: 'custom-like-sweet',
      autoFocus: false,
      disableClose: true
    })
  }

  recoverPassword() {
    window.top.location.href = this.environmentService.virtualOfficeFront + 'usuario/password-recovery';
  }
  register() {
    window.top.location.href = this.environmentService.virtualOfficeFront + 'usuario/register';
  }
}
